/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'badge': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M9.995 2a5 5 0 014.339 7.486l3.113 5.191c.237.411-.007.895-.428.922l-.1-.002-2.498-.257-1.026 2.292c-.184.41-.721.438-1.002.086l-.06-.089-2.322-4.225-2.354 4.225c-.238.412-.779.442-1.013.09l-.049-.087L5.57 15.34l-2.497.257c-.448.046-.74-.405-.575-.824l.046-.096 3.052-5.3A5 5 0 019.996 2zm3.571 8.5a4.991 4.991 0 01-2.998 1.468l2.189 4.035.73-1.626a.55.55 0 01.447-.327h.12l1.77.18zm-7.213-.074L4.164 14.23l1.772-.18a.549.549 0 01.507.224l.06.103.729 1.625 2.228-4.03a4.99 4.99 0 01-3.107-1.546zm3.642-7.315a3.889 3.889 0 10.002 7.778 3.889 3.889 0 00-.003-7.778z" _fill="#01B9CA" fill-rule="evenodd"/>'
  }
})
